export const transformPrice = (price: number) => {
  const priceString = price.toString();
  return `${priceString.substring(0, 2) + "." + priceString.substring(2)},-`;
};
